fragment Category on category_Entry {
    __typename
    sectionHandle
    id
    title
    uri
    slug
    postDate
}
